module.exports = __webpack_public_path__ + "static/media/25.bbb696f0.png";